<!-- <ng-container *ngIf="(iframeSrc$|async) as iframeSrc">
<iframe  [src]="iframeSrc" frameborder="0" (load)="onIframeLoaded($event.target)"></iframe>
</ng-container> -->

@if (iframeSrc$ | async; as iframeSrc) {
  <pcp-emm-iframe
    [iframeSrc]="iframeSrc"
    (messageFromIframe)="onMessageFromIframe($event)"
  ></pcp-emm-iframe>
}
